// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const TargetTypeSchema = z.enum(['WEB_APPLICATION','EXTERNAL_NETWORK','AI_APPLICATION','INTERNAL_NETWORK'] as const);

export type TargetTypeType = `${z.infer<typeof TargetTypeSchema>}`

export default TargetTypeSchema;
